import React from "react";
import "../css/PageLoader.css";

const PageLoader = ({ text = "Loading..." }) => {
  return (
    <div className="page-loader">
      <div className="loader-card">
        <div className="loader-spinner"></div>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default PageLoader;